import axiosInstance from "./axiosInstance";
import { API_URL } from "../Config/config";

const normalizeUploadPayload = (payload, fallbackMessage) => {
  const data = payload?.data || payload || {};
  const errors = data.errors || payload?.errors || [];
  return {
    message: payload?.message || fallbackMessage,
    data: {
      ...data,
      errors: Array.isArray(errors) ? errors : [],
    },
  };
};

const uploadStockFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post(
      API_URL + "stock-upload/upload",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    const normalized = normalizeUploadPayload(
      response.data,
      "Stock uploaded successfully"
    );
    const uploadStatus = normalized.data?.status;
    const ok =
      response.status < 400 &&
      uploadStatus !== "FAILED";
    return {
      status: ok,
      message: normalized.message,
      data: normalized.data,
    };
  } catch (err) {
    const body = err?.response?.data;
    const normalized = normalizeUploadPayload(
      body,
      err?.message || "Failed to upload stock file"
    );
    // API may put errors under data.errors or top-level
    if (!normalized.data.errors?.length && body?.data?.errors) {
      normalized.data.errors = body.data.errors;
    }
    if (!normalized.data.summary_s3_url && body?.data?.summary_s3_url) {
      normalized.data.summary_s3_url = body.data.summary_s3_url;
    }
    return {
      status: false,
      message: normalized.message,
      data: normalized.data,
    };
  }
};

const getStockUploadList = async (filter = {}) => {
  try {
    const params = {
      limit: filter.limit || 10,
      offset: filter.offset || 1,
    };
    if (filter.file_name) params.file_name = filter.file_name;
    if (filter.status) params.status = filter.status;
    if (filter.start_date) params.start_date = filter.start_date;
    if (filter.end_date) params.end_date = filter.end_date;

    const response = await axiosInstance.get(API_URL + "stock-upload/list", {
      params,
    });
    return {
      status: true,
      data: response.data?.data?.rows || [],
      count: response.data?.data?.count || 0,
      pagination: response.data?.data?.pagination || {},
    };
  } catch (err) {
    return {
      status: false,
      message:
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch stock upload list",
      data: [],
      count: 0,
    };
  }
};

const downloadSampleFormat = async () => {
  try {
    const response = await axiosInstance.get(
      API_URL + "stock-upload/sample-format",
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "bremskerl_stock_upload_sample.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    return { status: true };
  } catch (err) {
    return {
      status: false,
      message:
        err?.response?.data?.message ||
        err?.message ||
        "Failed to download sample format",
    };
  }
};

export default {
  uploadStockFile,
  getStockUploadList,
  downloadSampleFormat,
};
